"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _applet = require("@/api/operation/applet.js");
var _enums = require("./enums");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      loading: false
    };
  },
  computed: {
    formData: function formData() {
      return [
      // { label: '用户搜索', prop: 'user', type: 'user-select-input' },
      {
        label: '应用名称',
        prop: 'appName',
        defaultValue: '',
        type: 'input'
      }, {
        label: '应用环境',
        prop: 'appType',
        defaultValue: '',
        type: 'select',
        options: {
          list: _enums.appTypeOptions
        }
      }, {
        label: '状态',
        prop: 'status',
        defaultValue: '',
        type: 'select',
        options: {
          list: _enums.statusOptions
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'id',
        visible: true,
        label: "ID",
        width: 140
      }, {
        key: 'appName',
        visible: true,
        label: "\u5E94\u7528\u540D\u79F0"
      },
      // { key: 'appCategory', visible: true, label: `应用分类`, width: 100, formatter: 'tag', formatOptions: { list: appCategoryOptions } },
      {
        key: 'appType',
        visible: true,
        label: "\u5E94\u7528\u73AF\u5883",
        width: 100,
        formatter: 'tag',
        formatOptions: {
          list: _enums.appTypeOptions
        }
      }, {
        key: 'appId',
        visible: true,
        label: "\u5C0F\u7A0B\u5E8Fappid",
        width: 100
      }, {
        key: 'domain',
        visible: true,
        label: "\u516C\u4F17\u53F7\u57DF\u540D",
        width: 100
      }, {
        key: 'status',
        visible: true,
        label: "\u72B6\u6001",
        width: 100,
        formatter: 'tag',
        formatOptions: {
          list: _enums.statusOptions
        }
      }];
    }
  },
  methods: {
    getList: function getList(params) {
      return (0, _applet.appletListApi)(params);
    },
    //添加商品
    handleAdd: function handleAdd() {
      this.$router.push({
        path: "/operation/applet/operate/0/add"
      });
    },
    //商品操作
    handleActivity: function handleActivity(row, operate) {
      //id:商品id，operate：操作类型(edit编辑，copy复制，detail详情不可编辑)
      this.$router.push({
        path: "/operation/applet/operate/".concat(row.id, "/").concat(operate)
      });
    },
    handleStatusChange: function handleStatusChange(row) {
      var _this = this;
      var params = {
        id: row.id,
        status: row.status
      };
      (0, _applet.appletUpdateStatusApi)(params).then(function (res) {
        _this.$message.success('更新状态成功');
        _this.$refs.searchPage.refresh();
      }).catch(function () {
        _this.$message.error('更新状态失败');
        row.status = row.status ? 0 : 1;
      });
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$modal.confirm('是否确认删除？').then(function () {
        return (0, _applet.appletDeleteApi)(row.id);
      }).then(function () {
        _this2.$refs.searchPage.refresh();
        _this2.$modal.msgSuccess('删除成功');
      }).catch(function () {});
    }
  }
};